module.exports = __webpack_public_path__ + "img/vs.d63ef5aa.png";